import z from "zod"
import { Errors } from "../../errors"

export const UpsertGorgiasIntegrationSchema = z.object({
  baseApiUrl: z.string().min(1, { message: Errors.GORGIAS_BASE_API_URL_REQUIRED }),
  token: z.string().min(1, { message: Errors.GORGIAS_TOKEN_REQUIRED }),
  username: z.string().min(1, { message: Errors.GORGIAS_USERNAME_REQUIRED }),
})
